import styled, { css } from 'styled-components'
import { Spacing, Colors, Typography } from 'cio-design-library/design-tokens'
import Media from 'builder/styles/media'
import Icon from 'builder/components/Icon'

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 544px;
  border-radius: ${Spacing.S};
  background-color: ${Colors.White};
  padding: 32px;

  ${Media.Phone`
    width: 343px;
    border-radius: 12px;
  `}
`

export const CloseIconWrapper = styled.div<{ showHoverState: boolean }>(({ showHoverState }) => {
  return css`
    ${showHoverState
      ? ''
      : `& svg {
          &:hover {
            background: ${Colors.White};
            fill: ${Colors.Neutral70};
            cursor: default;
          }
        }`}
  `
})

export const CloseIcon = styled(Icon.AddSmall)`
  fill: ${Colors.Neutral70};
  background: ${Colors.White};
  border-radius: 50%;
  position: absolute;
  left: 484px;
  top: 24px;
  height: 28px;
  width: 28px;
  cursor: pointer;
  transform: rotate(225deg);

  &:hover {
    background: ${Colors.Blue50};
    fill: ${Colors.White};
  }

  ${Media.Phone`
    height: 24px;
    width: 24px;
    left: 299px;
    top: 20px;
    z-index: 2;
  `}
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex-grow: 1;
`

export const Title = styled.p`
  ${Typography.sizes.S};
  font-weight: ${Typography.weights.demibold};
  margin-bottom: 12px;

  ${Media.Phone`
    margin-bottom: 8px;
  `}
`

export const ModalTitle = styled.p`
  font-family: 'TT Talent';
  font-size: var(--Text-Style-Size-S, 23px);
  font-style: normal;
  font-weight: 600;
  line-height: var(--Text-Style-Line-Height-S, 24px); /* 104.348% */
  color: ${Colors.Neutral90};
  margin: auto 0;
`

export const ButtonContainer = styled.div`
  display: flex;
  gap: ${Spacing['2XS']};
`

export const UnlockFeaturesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const ModalFeaturesContainer = styled.ul`
  display: flex;
  padding: 16px 20px;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  align-self: stretch;
  border-radius: 12px;
  list-style-type: none;
  margin-block-start: 0;
  margin-block-end: 0;
`

export const GotItRightContainer = styled(ModalFeaturesContainer)`
  background: ${Colors.Green10};
`

export const HelpImproveContainer = styled(ModalFeaturesContainer)`
  background: ${Colors.Neutral5};
`

export const FeatureTitle = styled.span`
  color: ${Colors.Neutral50};

  font-family: 'TT Talent';
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
  letter-spacing: 1.8px;
  text-transform: uppercase;
`

// icons
export const NoCompletedIcon = styled.img`
  width: 24px;
  height: 24px;
`
export const CompletedIcon = styled.img`
  width: 24px;
  height: 24px;
`
export const WarningImage = styled.img`
  width: 32px;
  height: 32px;
  aspect-ratio: 1/1;
`

export const FeatureItem = styled.li`
  display: flex;
  gap: 8px;
`

export const AIModalTitleContainer = styled.div`
  display: flex;
  gap: 10px;
`
